module.exports = __webpack_public_path__ + "img/g7.4ad2cf4c.png";